import { createBrowserRouter, Navigate, Outlet, useLocation } from "react-router-dom";
import ProtectedRoute from "./components/base-component/ProtectedRoute";
import {
  ADC_COST,
  CRM_PATHS,
  GUIDLINE_PATHS,
  HRM_PATHS,
  MASTER_FORM,
  MASTER_PATHS,
  MTC_PATHS,
  NEW_SHIPMENT_PATHS,
  NOTIFICATIONS_PATHS,
  PUBLIC_PATHS,
  REPORTS_PATH,
  ROADMAP_PATHS,
  SHIPMENT_PATHS,
  TMS_PATHS,
} from "./constances/Paths.constance";
import { lazy, Suspense } from "react";
import MainLayout from "./pages/base/layouts/MainLayout";
import { Header } from "./pages/base/components/headers/Header";
import { CommonSpin } from "./pages/base/components/spin/CommonSpin";
import CheckInCheckOutContainer from "./pages/new-shipment/driver/CheckInCheckOutTrucking";
const DashboardOfAdcCosts = lazy(() => import("./pages/adc-costs/DashboardOfAdcCosts"));
const RoleManagementDashboardPage = lazy(() => import("./pages/hrm/authz/RoleManagementDashboardPage"));
const DashboardOfHRM = lazy(() => import("./pages/hrm/DashboardOfHRM"));
const ApplicationRequestsPage = lazy(() => import("./pages/hrm/ApplicationRequestsPage"));
const ApplicationRequestsDetailPage = lazy(() => import("./pages/hrm/ApplicationRequestsDetailPage"));
const HomePage = lazy(() => import("./pages/base/HomePage"));
const EmployeeManagementPage = lazy(() => import("./pages/hrm/EmployeeManagementPage"));
const EmployeeProfile = lazy(() => import("./pages/hrm/EmployeeProfilePage"));
const MyProfile = lazy(() => import("./pages/hrm/MyProfilePage"));
const JobTitleAuthzPage = lazy(() => import("./pages/hrm/authz/JobTitleAuthzPage"));
const RoleManagementPage = lazy(() => import("./pages/hrm/authz/RoleManagementPage"));
const GrantManagementPage = lazy(() => import("./pages/hrm/authz/GrantManagementPage"));
const CompanyGroupPage = lazy(() => import("./pages/hrm/org/CompanyGroupPage"));
const CompanyPage = lazy(() => import("./pages/hrm/org/CompanyPage"));
const DepartmentFunctionPage = lazy(() => import("./pages/hrm/org/DepartmentFunctionPage"));
const BranchPage = lazy(() => import("./pages/hrm/org/BranchPage"));
const DepartmentPage = lazy(() => import("./pages/hrm/org/DepartmentPage"));
const TeamPage = lazy(() => import("./pages/hrm/org/TeamPage"));
const MtcPage = lazy(() => import("./pages/mtc/MtcPage"));
const ContainerAccessLogging = lazy(() => import("./pages/mtc/ContainerAccessLogging"));
const ApprovalSettingPage = lazy(() => import("./pages/master/approval-settings/ApprovalSettingsPage"));
const ShipmentInfoPage = lazy(() => import("./pages/shipment/ShipmentInfoPage"));
const ShipmentInfoPageDetail = lazy(() => import("./pages/shipment/ShipmentInfoPageDetail"));
const ProjectInvoiceCostPage = lazy(() => import("./pages/cost/ProjectInvoiceCostPage"));
const CustomerAccountManagementPage = lazy(() => import("./pages/master/CustomerAccountManagementPage"));
const RoadmapPage = lazy(() => import("./pages/roadmap/RoadmapPage"));
const LicensePage = lazy(() => import("./pages/license/LicensePage"));
const AssignmentTruckingPage = lazy(() => import("./pages/container/AssignmentTruckingPage"));
const ProjectContainerGrid = lazy(() => import("./pages/shipment/ProjectContainerFullListPage"));
const ProjectInvoiceCostPageDetail = lazy(() => import("./pages/cost/ProjectInvoiceCostPageDetail"));
const MasterPayeeRegisterPage = lazy(() => import("./pages/master/MasterPayeeRegisterPage"));
const ImportDataShipmentInfo = lazy(() =>
  import("./components/shipment-component/ImportDataShipmentInfo").then((module) => ({ default: module.ImportDataShipmentInfo })),
);
const ImportDataProjectInvoiceCost = lazy(() => import("./components/cost-component/ImportDataProjectInvoiceCost"));
const MasterCarrierRegisterPage = lazy(() => import("./pages/master/MasterCarrierRegisterPage"));
const MasterShipperPage = lazy(() => import("./pages/master/shippers/MasterShipperPage"));
const MasterCneePage = lazy(() => import("./pages/master/cnees/MasterCneePage"));
const MasterCarrierPage = lazy(() => import("./pages/master/carriers/MasterCarrierPage"));
const AdminPostManagementPage = lazy(() => import("./pages/post/admin/AdminPostManagementPage"));
const UserPostPage = lazy(() => import("./pages/post/user/UserPostPage"));
const AdminPostCreatePage = lazy(() => import("./pages/post/admin/AdminPostCreatePage"));
const AdminPostDetailPage = lazy(() => import("./pages/post/admin/AdminPostDetailPage"));
const UserPostDetailPage = lazy(() => import("./pages/post/user/UserPostDetailPage"));
const ImportDataCdsInvoiceCost = lazy(() => import("./components/cost-component/ImportDataCdsInvoiceCost"));
const MasterFormRegisterPage = lazy(() => import("./pages/master/forms/MasterFormRegisterPage"));
const MasterFormPage = lazy(() => import("./pages/master/forms/MasterFormPage"));
const MasterFormDetailPage = lazy(() => import("./pages/master/forms/MasterFormDetailPage"));
const FormsLayout = lazy(() => import("./pages/applications/layouts/FormsLayout"));
const ApplicationsSentToMeDetailPage = lazy(() => import("./pages/applications/ApplicationsSentToMeDetailPage"));
const MyApplicationsDetailPage = lazy(() => import("./pages/applications/MyApplicationsDetailPage"));
const ApplicationTypesPage = lazy(() => import("./pages/applications/ApplicationTypesPage"));
const CustomerManagementPage = lazy(() => import("./pages/crm/pages/CustomerManagementPage"));
const ShipmentPage = lazy(() => import("./pages/new-shipment/ShipmentPage"));
const CdsActionTable = lazy(() => import("./pages/new-shipment/cds-action/CdsActionTable"));
const TruckingActionManagementPage = lazy(() => import("./pages/tms/trucking-action/TruckingActionManagementPage"));
const UnauthorizedPage = lazy(() => import("./pages/base/UnauthorizedPage"));
const ShipmentCostDetailPage = lazy(() => import("./pages/new-shipment/cost/ShipmentCostDetailPage"));
const ShipmentReceivableDetailPage = lazy(() => import("./pages/new-shipment/cost/ShipmentReceivableDetailPage"));
const CdsPage = lazy(() => import("./pages/new-shipment/CdsPage"));
const ShipmentCostSettingPage = lazy(() => import("./pages/new-shipment/shipment-cost-form-settings/ShipmentCostSettingPage"));
const CostPage = lazy(() => import("./pages/new-shipment/CostPage"));
const NewLicensePage = lazy(() => import("./pages/new-shipment/NewLicensePage"));
const TruckingPage = lazy(() => import("./pages/new-shipment/TruckingPage"));
const LocationAddressManagementPage = lazy(() => import("./pages/master/locations/LocationAddressManagementPage"));
const BillPage = lazy(() => import("./pages/new-shipment/BillPage"));
const UploadCdsPage = lazy(() => import("./pages/new-shipment/UploadCdsPage"));
const NotFoundPage = lazy(() => import("./pages/base/NotFoundPage"));
const PnlPage = lazy(() => import("./pages/reports/PnlPage"));
const ReportsOverviewPage = lazy(() => import("./pages/reports/ReportsOverviewPage"));
const RevenueDetailPage = lazy(() => import("./pages/revenue/RevenueDetailPage"));
const NotificationsPage = lazy(() => import("./pages/notifications/NotificationsPage"));
const MessagesPage = lazy(() => import("./pages/messages/MessagesPage"));
const DashboardTMS = lazy(() => import("./pages/tms/DashboardTMS"));
const VendorInformationPage = lazy(() => import("./pages/tms/VendorInformationPage"));
const FleetManagementPage = lazy(() => import("./pages/tms/FleetManagementPage"));
const TruckingPlanDispatchPage = lazy(() => import("./pages/tms/TruckingPlanDispatchPage"));
const TmsApprovalSettingPage = lazy(() => import("./pages/tms/trucking-cost-approval/TmsApprovalSettingPage"));
const TruckingPlanListPage = lazy(() => import("./pages/new-shipment/trucking-plan/TruckingPlanListPage"));

const AdvancePaymentPage = lazy(() => import("./pages/adc-costs/advance-payment-expense/AdvancePaymentPage"));
const AdvancePaymentDetailPage = lazy(() => import("./pages/adc-costs/advance-payment-expense/AdvancePaymentDetailPage"));
const PaymentRequestPage = lazy(() => import("./pages/adc-costs/payment-request/PaymentRequestPage"));
const PaymentRequestDetailPage = lazy(() => import("./pages/adc-costs/payment-request/PaymentRequestDetailPage"));
const routeFallback = <CommonSpin fullscreen />;

const AppRouteFrame = () => {
  const { pathname } = useLocation();

  if (pathname === "/") {
    return (
      <>
        <Header />
        <Suspense fallback={routeFallback}>
          <Outlet />
        </Suspense>
      </>
    );
  }

  return (
    <Suspense fallback={routeFallback}>
      <MainLayout />
    </Suspense>
  );
};

const router = createBrowserRouter([
  {
    element: <AppRouteFrame />,
    children: [
      {
        path: "/",
        element: (
          <ProtectedRoute>
            <HomePage />
          </ProtectedRoute>
        ),
      },
      {
        path: "/unauthorized",
        element: <UnauthorizedPage />,
      },
      {
        path: ROADMAP_PATHS.ROOT,
        element: (
          <ProtectedRoute roles={["EMPLOYEE"]}>
            <RoadmapPage />
          </ProtectedRoute>
        ),
      },
      {
        path: NOTIFICATIONS_PATHS.ROOT,
        element: (
          <ProtectedRoute roles={["EMPLOYEE"]}>
            <NotificationsPage />
          </ProtectedRoute>
        ),
      },
      {
        path: "/messages",
        element: (
          <ProtectedRoute>
            <MessagesPage />
          </ProtectedRoute>
        ),
      },
      {
        path: HRM_PATHS.ROOT,
        children: [
          {
            index: true,
            element: (
              <ProtectedRoute roles={["EMPLOYEE"]}>
                <DashboardOfHRM />
              </ProtectedRoute>
            ),
          },
          {
            path: HRM_PATHS.EMPLOYEE_MANAGEMENT,
            element: (
              <ProtectedRoute roles={["EMPLOYEE"]}>
                <EmployeeManagementPage />
              </ProtectedRoute>
            ),
          },
          {
            path: HRM_PATHS.EMPLOYEE_PROFILE,
            element: (
              <ProtectedRoute roles={["EMPLOYEE_UPDATE_ANY"]}>
                <EmployeeProfile />
              </ProtectedRoute>
            ),
          },
          {
            path: HRM_PATHS.MY_PROFILE,
            element: (
              <ProtectedRoute roles={["EMPLOYEE"]}>
                <MyProfile />
              </ProtectedRoute>
            ),
          },
          {
            path: HRM_PATHS.ROLE_MANAGEMENT,
            element: (
              <ProtectedRoute roles={["HRM_ROLE_MANAGE"]}>
                <RoleManagementDashboardPage />
              </ProtectedRoute>
            ),
          },
          {
            path: HRM_PATHS.APPLICATION_REQUESTS,
            element: (
              <ProtectedRoute roles={["EMPLOYEE"]}>
                <ApplicationRequestsPage />
              </ProtectedRoute>
            ),
          },
          {
            path: `${HRM_PATHS.APPLICATION_REQUESTS}/:scope/:formTypeId`,
            element: (
              <ProtectedRoute roles={["EMPLOYEE"]}>
                <ApplicationRequestsDetailPage />
              </ProtectedRoute>
            ),
          },
          {
            path: HRM_PATHS.AUTHZ_JOB_TITLES,
            element: (
              <ProtectedRoute roles={["HRM_ROLE_MANAGE"]}>
                <JobTitleAuthzPage />
              </ProtectedRoute>
            ),
          },
          {
            path: HRM_PATHS.AUTHZ_ROLES,
            element: (
              <ProtectedRoute roles={["HRM_ROLE_MANAGE"]}>
                <RoleManagementPage />
              </ProtectedRoute>
            ),
          },
          {
            path: HRM_PATHS.AUTHZ_GRANTS,
            element: (
              <ProtectedRoute roles={["HRM_ROLE_MANAGE"]}>
                <GrantManagementPage />
              </ProtectedRoute>
            ),
          },
          {
            path: HRM_PATHS.ORG_COMPANY_GROUPS,
            element: (
              <ProtectedRoute roles={["EMPLOYEE"]}>
                <CompanyGroupPage />
              </ProtectedRoute>
            ),
          },
          {
            path: HRM_PATHS.ORG_COMPANIES,
            element: (
              <ProtectedRoute roles={["EMPLOYEE"]}>
                <CompanyPage />
              </ProtectedRoute>
            ),
          },
          {
            path: HRM_PATHS.ORG_DEPARTMENT_FUNCTIONS,
            element: (
              <ProtectedRoute roles={["EMPLOYEE"]}>
                <DepartmentFunctionPage />
              </ProtectedRoute>
            ),
          },
          {
            path: HRM_PATHS.ORG_BRANCHES,
            element: (
              <ProtectedRoute roles={["EMPLOYEE"]}>
                <BranchPage />
              </ProtectedRoute>
            ),
          },
          {
            path: HRM_PATHS.ORG_DEPARTMENTS,
            element: (
              <ProtectedRoute roles={["EMPLOYEE"]}>
                <DepartmentPage />
              </ProtectedRoute>
            ),
          },
          {
            path: HRM_PATHS.ORG_TEAMS,
            element: (
              <ProtectedRoute roles={["EMPLOYEE"]}>
                <TeamPage />
              </ProtectedRoute>
            ),
          },
        ],
      },
      {
        path: CRM_PATHS.ROOT,
        children: [
          {
            index: true,
            element: (
              <ProtectedRoute roles={["MASTER_CUSTOMER_VIEW"]}>
                <CustomerManagementPage />
              </ProtectedRoute>
            ),
          },
        ],
      },
      {
        path: TMS_PATHS.ROOT,
        children: [
          {
            index: true,
            element: (
              <ProtectedRoute roles={["TMS_DISPATCH"]}>
                <DashboardTMS />
              </ProtectedRoute>
            ),
          },
          {
            path: TMS_PATHS.VENDOR,
            element: (
              <ProtectedRoute roles={["TMS_DISPATCH"]}>
                <VendorInformationPage />
              </ProtectedRoute>
            ),
          },
          {
            path: TMS_PATHS.VENDOR_DETAIL,
            element: (
              <ProtectedRoute roles={["TMS_DISPATCH"]}>
                <VendorInformationPage />
              </ProtectedRoute>
            ),
          },
          {
            path: TMS_PATHS.FLEET_MANAGEMENT,
            element: (
              <ProtectedRoute roles={["TMS_DISPATCH"]}>
                <FleetManagementPage />
              </ProtectedRoute>
            ),
          },
          {
            path: TMS_PATHS.TRUCKING_PLAN_DISPATCH,
            element: (
              <ProtectedRoute roles={["TMS_DISPATCH"]}>
                <TruckingPlanDispatchPage />
              </ProtectedRoute>
            ),
          },
          {
            path: TMS_PATHS.TRUCKING_PLAN_DISPATCH_DETAIL,
            element: (
              <ProtectedRoute roles={["TMS_DISPATCH"]}>
                <TruckingPlanDispatchPage />
              </ProtectedRoute>
            ),
          },
          {
            path: TMS_PATHS.SHIPMENT_RECEIVABLE_COST_DETAIL,
            element: (
              <ProtectedRoute roles={["TMS_DISPATCH"]}>
                <TruckingPlanDispatchPage />
              </ProtectedRoute>
            ),
          },
          {
            path: TMS_PATHS.TMS_OPERATING_COST_DETAIL,
            element: (
              <ProtectedRoute roles={["TMS_DISPATCH"]}>
                <TruckingPlanDispatchPage />
              </ProtectedRoute>
            ),
          },
          {
            path: TMS_PATHS.TRUCKING,
            element: (
              <ProtectedRoute roles={["TMS_DISPATCH"]}>
                <TruckingPage />
              </ProtectedRoute>
            ),
          },
          {
            path: TMS_PATHS.TRUCKING_DETAIL,
            element: (
              <ProtectedRoute roles={["TMS_DISPATCH"]}>
                <TruckingPage />
              </ProtectedRoute>
            ),
          },
          {
            path: TMS_PATHS.COST_APPROVAL_SETTING,
            element: (
              <ProtectedRoute roles={["TMS_COST_APPROVAL_SETTING"]}>
                <TmsApprovalSettingPage />
              </ProtectedRoute>
            ),
          },
          {
            path: TMS_PATHS.TRUCKING_ACTION_SETTING,
            element: (
              <ProtectedRoute roles={["MASTER_TRUCKING_ACTION"]}>
                <TruckingActionManagementPage />
              </ProtectedRoute>
            ),
          },
        ],
      },
      {
        path: MTC_PATHS.ROOT,
        element: (
          <ProtectedRoute roles={["EMPLOYEE"]}>
            <MtcPage />
          </ProtectedRoute>
        ),
      },
      { path: PUBLIC_PATHS.ACCESS_LOGGING, element: <ContainerAccessLogging /> },
      {
        path: PUBLIC_PATHS.CHECKIN_CHECKOUT,
        element: <CheckInCheckOutContainer />,
      },
      {
        path: MASTER_PATHS.ROOT,
        children: [
          {
            path: MASTER_PATHS.MASTER_FORM_PAGE,
            element: (
              <ProtectedRoute roles={["MASTER_FORM_VIEW"]}>
                <MasterFormPage />
              </ProtectedRoute>
            ),
          },
          {
            path: MASTER_PATHS.MASTER_FORM_REGISTER,
            element: (
              <ProtectedRoute roles={["MASTER_FORM_CREATE"]}>
                <MasterFormRegisterPage />
              </ProtectedRoute>
            ),
          },
          {
            path: MASTER_PATHS.MASTER_FORM_DETAIL,
            element: (
              <ProtectedRoute roles={["MASTER_FORM_VIEW"]}>
                <MasterFormDetailPage />
              </ProtectedRoute>
            ),
          },
          {
            path: MASTER_PATHS.APPROVAL_SETTINGS,
            element: (
              <ProtectedRoute roles={["MASTER_APPROVAL_SETTING_VIEW"]}>
                <ApprovalSettingPage />
              </ProtectedRoute>
            ),
          },
          {
            path: MASTER_PATHS.CUSTOMER_ACCOUNT_MANAGEMENT,
            element: (
              <ProtectedRoute roles={["EMPLOYEE"]}>
                <CustomerAccountManagementPage />
              </ProtectedRoute>
            ),
          },
          {
            path: MASTER_PATHS.PAYEE_REGISTER,
            element: (
              <ProtectedRoute roles={["EMPLOYEE"]}>
                <MasterPayeeRegisterPage />
              </ProtectedRoute>
            ),
          },
          {
            path: MASTER_PATHS.CARRIER_REGISTER,
            element: (
              <ProtectedRoute roles={["EMPLOYEE"]}>
                <MasterCarrierRegisterPage />
              </ProtectedRoute>
            ),
          },
          {
            path: MASTER_PATHS.SHIPPER_PAGE,
            element: (
              <ProtectedRoute roles={["EMPLOYEE"]}>
                <MasterShipperPage />
              </ProtectedRoute>
            ),
          },
          {
            path: MASTER_PATHS.CNEE_PAGE,
            element: (
              <ProtectedRoute roles={["EMPLOYEE"]}>
                <MasterCneePage />
              </ProtectedRoute>
            ),
          },
          {
            path: MASTER_PATHS.CARRIER_PAGE,
            element: (
              <ProtectedRoute roles={["EMPLOYEE"]}>
                <MasterCarrierPage />
              </ProtectedRoute>
            ),
          },
          {
            path: MASTER_PATHS.LOCATION_ADDRESS,
            element: (
              <ProtectedRoute roles={["EMPLOYEE"]}>
                <LocationAddressManagementPage />
              </ProtectedRoute>
            ),
          },
        ],
      },
      {
        path: SHIPMENT_PATHS.ROOT,
        children: [
          {
            index: true,
            element: (
              <ProtectedRoute roles={["EMPLOYEE"]}>
                <ShipmentInfoPage />
              </ProtectedRoute>
            ),
          },
          {
            path: `${SHIPMENT_PATHS.ROOT}/detail/:bookingBillNo`,
            element: (
              <ProtectedRoute roles={["EMPLOYEE"]}>
                <ShipmentInfoPageDetail />
              </ProtectedRoute>
            ),
          },
          {
            path: SHIPMENT_PATHS.CDS,
            element: (
              <ProtectedRoute roles={["EMPLOYEE"]}>
                <ShipmentInfoPage />
              </ProtectedRoute>
            ),
          },
          {
            path: SHIPMENT_PATHS.CONTAINER,
            element: (
              <ProtectedRoute roles={["EMPLOYEE"]}>
                <ShipmentInfoPage />
              </ProtectedRoute>
            ),
          },
          {
            path: SHIPMENT_PATHS.SPEACIALIZED_LICENSE_INFOMATION,
            element: (
              <ProtectedRoute roles={["EMPLOYEE"]}>
                <LicensePage />
              </ProtectedRoute>
            ),
          },
          {
            path: SHIPMENT_PATHS.IMPORT_DATA,
            element: (
              <ProtectedRoute roles={["EMPLOYEE"]}>
                <ImportDataShipmentInfo />
              </ProtectedRoute>
            ),
          },

          {
            path: SHIPMENT_PATHS.ASSIGNMENT_TRUCKING,
            element: (
              <ProtectedRoute roles={["EMPLOYEE"]}>
                <AssignmentTruckingPage />
              </ProtectedRoute>
            ),
          },

          {
            path: SHIPMENT_PATHS.FULL_LIST_CONTAINER,
            element: (
              <ProtectedRoute roles={["EMPLOYEE"]}>
                <ProjectContainerGrid />
              </ProtectedRoute>
            ),
          },
        ],
      },

      {
        path: NEW_SHIPMENT_PATHS.ROOT,
        children: [
          {
            index: true,
            element: (
              <ProtectedRoute roles={["EMPLOYEE"]}>
                <ShipmentPage />
              </ProtectedRoute>
            ),
          },
          {
            path: ":id",
            element: (
              <ProtectedRoute roles={["EMPLOYEE"]}>
                <ShipmentPage />
              </ProtectedRoute>
            ),
          },

          {
            path: NEW_SHIPMENT_PATHS.MASTER_CDS_ACTION,
            element: (
              <ProtectedRoute roles={["MASTER_CDS_ACTION_VIEW"]}>
                <CdsActionTable />
              </ProtectedRoute>
            ),
          },
          {
            path: NEW_SHIPMENT_PATHS.MASTER_TRUCKING_ACTION,
            element: (
              <ProtectedRoute roles={["MASTER_TRUCKING_ACTION"]}>
                <Navigate to={TMS_PATHS.TRUCKING_ACTION_SETTING} replace />
              </ProtectedRoute>
            ),
          },
          {
            path: NEW_SHIPMENT_PATHS.SHIPMENT_COST_SETTINGS,
            element: (
              <ProtectedRoute roles={["COST_FORM_SETTING", "REVENUE_APPROVAL_SETTING"]}>
                <ShipmentCostSettingPage />
              </ProtectedRoute>
            ),
          },
          {
            path: NEW_SHIPMENT_PATHS.CDS,
            element: (
              <ProtectedRoute roles={["EMPLOYEE"]}>
                <CdsPage />
              </ProtectedRoute>
            ),
          },
          {
            path: NEW_SHIPMENT_PATHS.TRUCKING,
            element: (
              <ProtectedRoute roles={["EMPLOYEE"]}>
                <TruckingPage readOnly />
              </ProtectedRoute>
            ),
          },
          {
            path: NEW_SHIPMENT_PATHS.TRUCKING_PLAN,
            element: (
              <ProtectedRoute roles={["EMPLOYEE"]}>
                <TruckingPlanListPage />
              </ProtectedRoute>
            ),
          },
          {
            path: NEW_SHIPMENT_PATHS.BILL,
            element: (
              <ProtectedRoute roles={["EMPLOYEE"]}>
                <BillPage />
              </ProtectedRoute>
            ),
          },
          {
            path: `${NEW_SHIPMENT_PATHS.COST}/*`,
            element: (
              <ProtectedRoute roles={["EMPLOYEE"]}>
                <CostPage />
              </ProtectedRoute>
            ),
          },
          {
            path: NEW_SHIPMENT_PATHS.NEW_LICENSE,
            element: (
              <ProtectedRoute roles={["EMPLOYEE"]}>
                <NewLicensePage />
              </ProtectedRoute>
            ),
          },
          {
            path: `${NEW_SHIPMENT_PATHS.REVENUE}/:revenueId`,
            element: (
              <ProtectedRoute roles={["EMPLOYEE"]}>
                <RevenueDetailPage />
              </ProtectedRoute>
            ),
          },
        ],
      },
      {
        path: REPORTS_PATH.ROOT,
        children: [
          {
            index: true,
            element: (
              <ProtectedRoute roles={["EMPLOYEE", "REPORT_VIEW"]}>
                <ReportsOverviewPage />
              </ProtectedRoute>
            ),
          },
          {
            path: REPORTS_PATH.RECEIVABLES_PNL,
            element: (
              <ProtectedRoute roles={["EMPLOYEE", "REPORT_VIEW"]}>
                <PnlPage />
              </ProtectedRoute>
            ),
          },
        ],
      },
      {
        path: "/new-shipments/:shipmentId/shipment-cost/:costId",
        element: (
          <ProtectedRoute roles={["EMPLOYEE"]}>
            <ShipmentCostDetailPage />
          </ProtectedRoute>
        ),
      },
      {
        path: "/new-shipments/:shipmentId/shipment-receivable/:receivableId",
        element: (
          <ProtectedRoute roles={["EMPLOYEE"]}>
            <ShipmentReceivableDetailPage />
          </ProtectedRoute>
        ),
      },
      {
        path: NEW_SHIPMENT_PATHS.UPLOAD_CDS,
        element: (
          <ProtectedRoute roles={["EMPLOYEE"]}>
            <UploadCdsPage />
          </ProtectedRoute>
        ),
      },
      {
        path: SHIPMENT_PATHS.COST,
        children: [
          {
            index: true,
            element: (
              <ProtectedRoute roles={["EMPLOYEE"]}>
                <ProjectInvoiceCostPage />
              </ProtectedRoute>
            ),
          },
          {
            path: SHIPMENT_PATHS.IMPORT_DATA_PROJECT_INVOICE_COST,
            element: (
              <ProtectedRoute roles={["EMPLOYEE"]}>
                <ImportDataProjectInvoiceCost />
              </ProtectedRoute>
            ),
          },
          {
            path: SHIPMENT_PATHS.IMPORT_DATA_CDS_INVOICE_COST,
            element: (
              <ProtectedRoute roles={["EMPLOYEE"]}>
                <ImportDataCdsInvoiceCost />
              </ProtectedRoute>
            ),
          },
          {
            path: `${SHIPMENT_PATHS.COST_DETAIL}:id`,
            element: (
              <ProtectedRoute roles={["EMPLOYEE"]}>
                <ProjectInvoiceCostPageDetail />
              </ProtectedRoute>
            ),
          },
        ],
      },

      {
        path: GUIDLINE_PATHS.ROOT,
        children: [
          {
            index: true,
            element: (
              <ProtectedRoute roles={["EMPLOYEE"]}>
                <UserPostPage />
              </ProtectedRoute>
            ),
            path: `${GUIDLINE_PATHS.ROOT}`,
          },
          {
            element: (
              <ProtectedRoute roles={["EMPLOYEE"]}>
                <UserPostDetailPage />
              </ProtectedRoute>
            ),
            path: `${GUIDLINE_PATHS.ROOT}/:id`,
          },
          {
            path: GUIDLINE_PATHS.ADMIN,
            element: (
              <ProtectedRoute roles={["POST_VIEW_ALL", "POST_CATEGORY_VIEW_ALL", "POST_TAG_VIEW_ALL"]}>
                <AdminPostManagementPage />
              </ProtectedRoute>
            ),
          },
          {
            path: GUIDLINE_PATHS.ADMIN_CREATE,
            element: (
              <ProtectedRoute roles={["POST_CREATE"]}>
                <AdminPostCreatePage />
              </ProtectedRoute>
            ),
          },
          {
            path: `${GUIDLINE_PATHS.ADMIN_DETAIL}/:id`,
            element: (
              <ProtectedRoute roles={["POST_UPDATE"]}>
                <AdminPostDetailPage />
              </ProtectedRoute>
            ),
          },
        ],
      },
      {
        path: MASTER_FORM.MY_APPLICATION,
        element: (
          <ProtectedRoute roles={["EMPLOYEE"]}>
            <FormsLayout />
          </ProtectedRoute>
        ),
        children: [
          {
            index: true,
            element: (
              <ProtectedRoute roles={["EMPLOYEE"]}>
                <ApplicationTypesPage isSendToMe={false} />
              </ProtectedRoute>
            ),
          },
        ],
      },
      {
        path: MASTER_FORM.SENT_TO_ME,
        element: (
          <ProtectedRoute roles={["EMPLOYEE"]}>
            <FormsLayout />
          </ProtectedRoute>
        ),
        children: [
          {
            index: true,
            element: (
              <ProtectedRoute roles={["EMPLOYEE"]}>
                <ApplicationTypesPage isSendToMe={true} />
              </ProtectedRoute>
            ),
          },
        ],
      },
      {
        path: `${MASTER_FORM.MY_APPLICATION}/:formTypeId`,
        element: (
          <ProtectedRoute roles={["EMPLOYEE"]}>
            <MyApplicationsDetailPage />
          </ProtectedRoute>
        ),
      },
      {
        path: `${MASTER_FORM.SENT_TO_ME}/:formTypeId`,
        element: (
          <ProtectedRoute roles={["EMPLOYEE"]}>
            <ApplicationsSentToMeDetailPage />
          </ProtectedRoute>
        ),
      },
      {
        path: `${ADC_COST.ROOT}`,
        children: [
          {
            index: true,
            element: (
              <ProtectedRoute roles={["EMPLOYEE"]}>
                <DashboardOfAdcCosts />
              </ProtectedRoute>
            ),
          },
          {
            path: `${ADC_COST.PAYMENT_REQUEST}`,
            element: (
              <ProtectedRoute roles={["EMPLOYEE"]}>
                <PaymentRequestPage />
              </ProtectedRoute>
            ),
          },
          {
            path: `${ADC_COST.PAYMENT_REQUEST}/:id`,
            element: (
              <ProtectedRoute roles={["EMPLOYEE"]}>
                <PaymentRequestDetailPage />
              </ProtectedRoute>
            ),
          },
          {
            path: `${ADC_COST.ADVANCE_PAYMENT}`,
            element: (
              <ProtectedRoute roles={["EMPLOYEE"]}>
                <AdvancePaymentPage />
              </ProtectedRoute>
            ),
          },
          {
            path: `${ADC_COST.ADVANCE_PAYMENT}/:id`,
            element: (
              <ProtectedRoute roles={["EMPLOYEE"]}>
                <AdvancePaymentDetailPage />
              </ProtectedRoute>
            ),
          },
        ],
      },
      {
        path: "*",
        element: (
          <ProtectedRoute>
            <NotFoundPage />
          </ProtectedRoute>
        ),
      },
    ],
  },
]);

export default router;
